import React from 'react';
import { SvgIcon } from '@mui/material';

const CustomLogo = (props) => {
  return (
    <SvgIcon
      {...props}
      viewBox="0 0 30 30"
      sx={{
        width: 30,
        height: 30,
        ...props.sx
      }}
    >
      <defs>
        <style>
          {`.st0 { fill: #060606; }`}
        </style>
      </defs>
      <path 
        className="st0" 
        d="M28.68,15.08s-.04,0-.06,0h-5.68c-.31,0-.57.25-.57.57v6.08c0,.15-.12.27-.27.27h-13.54c-.14,0-.26-.12-.26-.26v-13.5c0-.17.14-.31.31-.31h13.17c.33,0,.59-.26.59-.59V1.6c0-.33-.27-.59-.59-.59h-13.15c-.3,0-.55.25-.55.55v6.02c0,.2-.16.36-.36.36H1.59c-.24,0-.44.2-.44.44v13.44c0,.23.18.41.4.41h6.49c.14,0,.26.12.26.26v6.17c0,.27.22.49.49.49h13.06c.29,0,.52-.23.52-.52v-6.43c0-.11.09-.2.2-.2h6.22c.28,0,.5-.22.5-.5v-5.75c0-.35-.27-.64-.61-.67Z"
      />
      <path 
        className="st0" 
        d="M27.73,4.08c0,.81-.63,1.44-1.46,1.44s-1.46-.63-1.46-1.44.65-1.42,1.46-1.42,1.46.63,1.46,1.42ZM25.17,4.08c0,.63.47,1.13,1.11,1.13s1.08-.5,1.08-1.13-.46-1.14-1.09-1.14-1.1.51-1.1,1.13ZM26.05,4.82h-.33v-1.42c.13-.03.31-.04.55-.04.27,0,.39.04.49.1.08.06.14.17.14.31,0,.16-.12.28-.29.33v.02c.14.05.22.16.26.35.04.22.07.3.1.36h-.36c-.04-.05-.07-.18-.11-.35-.03-.16-.11-.23-.29-.23h-.16v.57ZM26.06,4.02h.16c.18,0,.33-.06.33-.21,0-.13-.1-.22-.3-.22-.09,0-.15,0-.18.02v.41Z"
      />
    </SvgIcon>
  );
};

export default CustomLogo;
